import moment from 'moment'

const swh = {
  objToStar: function () {},

  formatDate1: function (date) {
    if (!date) return null
    const [year, month, day] = date.split('-')

    return `${day}.${month}.${year}`
  },

  formatDate: (date, format) => {
    if (!format) format = 'DD.MM.YYYY'
    const utc = moment(date)
    // return utc.utcOffset('+01:00').format('DD.MM.YYYY')
    return utc.format(format)
  },

  isValid: (date) => {
    return moment(date).isValid()
  },

  parseDate: function (date) {
    if (!date) return null
    const [day, month, year] = date.split('.')

    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  },
}

export default swh
